var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useState } from "react";
import { Button, ConfirmationModal, Modal } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery, useQueryClient } from "react-query";
import { getHeaders } from "../../utils/apiUtils";
import styles from "./DepositRecordBackfill.module.css";
var formatElapsed = function (seconds) {
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return m > 0 ? "".concat(m, "m ").concat(s, "s") : "".concat(s, "s");
};
export var AdminJobPanel = function (_a) {
    var _b;
    var queryKey = _a.queryKey, statusPath = _a.statusPath, triggerPath = _a.triggerPath, i18nPrefix = _a.i18nPrefix, statFields = _a.statFields, resultBanner = _a.resultBanner;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClientInstance = useQueryClient();
    var _c = useState(false), showConfirm = _c[0], setShowConfirm = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var status = useQuery([queryKey], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, kyInstance.get(statusPath, {
                        headers: getHeaders(),
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    }); }, {
        refetchInterval: function (data) {
            return (data === null || data === void 0 ? void 0 : data.running) ? 3000 : false;
        },
    }).data;
    var isRunning = (_b = status === null || status === void 0 ? void 0 : status.running) !== null && _b !== void 0 ? _b : false;
    var hasResult = !isRunning && statFields.some(function (f) { return (status === null || status === void 0 ? void 0 : status[f.key]) != null; });
    var percentComplete = useMemo(function () {
        return typeof (status === null || status === void 0 ? void 0 : status.percentComplete) === "number"
            ? status.percentComplete
            : null;
    }, [status === null || status === void 0 ? void 0 : status.percentComplete]);
    var elapsedSeconds = useMemo(function () {
        return typeof (status === null || status === void 0 ? void 0 : status.elapsedSeconds) === "number"
            ? status.elapsedSeconds
            : null;
    }, [status === null || status === void 0 ? void 0 : status.elapsedSeconds]);
    var runJob = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowConfirm(false);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, kyInstance.post(triggerPath, { headers: getHeaders() })];
                case 2:
                    _a.sent();
                    queryClientInstance.invalidateQueries([queryKey]);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error("".concat(i18nPrefix, " start failed:"), e_1);
                    setError(e_1 instanceof Error
                        ? e_1.message
                        : formatMessage({ id: "".concat(i18nPrefix, ".error") }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: styles.container },
        React.createElement(FormattedMessage, { id: "".concat(i18nPrefix, ".title"), tagName: "h2" }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "".concat(i18nPrefix, ".description") })),
        React.createElement(Button, { buttonStyle: "primary", onClick: function () { return setShowConfirm(true); }, disabled: isRunning }, isRunning ? (React.createElement(FormattedMessage, { id: "".concat(i18nPrefix, ".button.running") })) : (React.createElement(FormattedMessage, { id: "".concat(i18nPrefix, ".button.start") }))),
        isRunning && percentComplete != null && (React.createElement("div", { className: styles.progressSection },
            React.createElement("div", { className: styles.progressHeader },
                React.createElement("span", null,
                    percentComplete,
                    "%"),
                elapsedSeconds != null && (React.createElement("span", { className: styles.elapsed }, formatElapsed(elapsedSeconds)))),
            React.createElement("div", { className: styles.progressBarTrack },
                React.createElement("div", { className: styles.progressBarFill, style: { width: "".concat(percentComplete, "%") } })),
            React.createElement("div", { className: styles.statsGrid }, statFields.map(function (field) {
                return (status === null || status === void 0 ? void 0 : status[field.key]) != null ? (React.createElement("div", { key: field.key, className: styles.statItem },
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: field.labelId }),
                        ":"),
                    React.createElement("span", null, status[field.key]))) : null;
            })))),
        hasResult && (React.createElement("div", { className: styles.result },
            resultBanner && status ? resultBanner(status) : null,
            elapsedSeconds != null && (React.createElement("div", { className: styles.progressHeader },
                React.createElement("span", null),
                React.createElement("span", { className: styles.elapsed }, formatElapsed(elapsedSeconds)))),
            React.createElement("div", { className: styles.statsGrid }, statFields.map(function (field) { return (React.createElement("div", { key: field.key, className: styles.statItem },
                React.createElement("span", { className: styles.statLabel },
                    React.createElement(FormattedMessage, { id: field.labelId }),
                    ":"),
                React.createElement("span", null, status === null || status === void 0 ? void 0 : status[field.key]))); })))),
        error && (React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "".concat(i18nPrefix, ".error.title") }), open: true, onClose: function () { return setError(null); }, dismissible: true }, error)),
        React.createElement(ConfirmationModal, { open: showConfirm, heading: formatMessage({ id: "".concat(i18nPrefix, ".confirm.heading") }), message: formatMessage({ id: "".concat(i18nPrefix, ".confirm.message") }), onConfirm: runJob, onCancel: function () { return setShowConfirm(false); }, confirmLabel: formatMessage({ id: "".concat(i18nPrefix, ".button.start") }) })));
};
